import { styled, Box } from '../../base';

export const PageWrapper = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.mainBackground,
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(6),
    },
}));

export const ContentBox = styled(Box)(() => ({
    flex: '1',
}));
